import type { AxiosInstance } from 'axios';
import authService from './auth.service';

/**
 * Closing a product to new clients (0072). Super admin only.
 *
 *   GET /api/v1/admin/products/new-client-access
 *   PUT /api/v1/admin/products/{id}/new-client-access
 */
export interface ProductAccess {
  product_id: string;
  product_name: string;
  /** Read live from the product's funds vehicle (0073); null when funds
   *  could not answer. */
  asset_class: string | null;
  is_active: boolean;
  /** Only a product mapped to a funds vehicle shows the closure in the funds console. */
  mapped_to_funds: boolean;
  closed: boolean;
  closed_at: string | null;
  closed_reason: string | null;
  closed_by_email: string | null;
  /** Evidence of exposure, not a count in law: distinct persons the product was shown to
   *  (catalogue, product page, proposal), and the outcome of each, derived from facts. */
  persons_shown?: number;
  accepted?: number;
  declined?: number;
  not_accepted?: number;
}

class ProductAccessService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async list(): Promise<ProductAccess[]> {
    const res = await this.api.get<ProductAccess[]>('/api/v1/admin/products/new-client-access');
    return res.data;
  }

  async setClosed(productId: string, closed: boolean, reason: string | null): Promise<ProductAccess> {
    const res = await this.api.put<ProductAccess>(
      `/api/v1/admin/products/${productId}/new-client-access`,
      { closed, reason },
    );
    return res.data;
  }
}

export default new ProductAccessService();
